<div fxFill fxLayout="column" [ngClass]="{'library-dialog-view': dialogGetAsset}" style="position: relative;">
    @if (!dialogGetAsset) {
        <button mat-button class="back-button-absolute" (click)="onBackClick()">
            <mat-icon>arrow_back</mat-icon>
            {{ 'general.resources' | transloco }}
        </button>
    }

    <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)" class="resource-tabs" animationDuration="0ms" tabGroupDrag mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon>account_tree</mat-icon>
                <span class="tab-label">{{ 'general.categorizedResources' | transloco }}</span>
            </ng-template>
            <div class="tab-content">
                <app-resources-library
                    [libraryType]="'categories'"
                    [dialogGetAsset]="dialogGetAsset"
                    (resourceSelected)="onResourceSelected($event)">
                </app-resources-library>
            </div>
        </mat-tab>

        @if (enterprise) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon>share</mat-icon>
                    <span class="tab-label">{{ 'general.sharedResources' | transloco }}</span>
                </ng-template>
                <div class="tab-content shared-resources-tab">
                    <div class="sync-button-container">
                        <button (click)="getEnterpriseSharedContent()" mat-stroked-button color="warn">
                            <mat-icon>cached</mat-icon>
                            {{ 'general.syncContent' | transloco }}
                        </button>
                    </div>
                    <app-resources-library
                        [libraryType]="'shared'"
                        [dialogGetAsset]="dialogGetAsset"
                        (resourceSelected)="onResourceSelected($event)">
                    </app-resources-library>
                </div>
            </mat-tab>
        }
    </mat-tab-group>
</div>

